"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducerGen = void 0;
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var loading_1 = require("remota-client/module/loading");
var notification_1 = require("remota-client/module/notification");
var login_1 = require("./login");
var multi_1 = require("./multi");
var reducerGen = function (history) {
    return (0, redux_1.combineReducers)({
        router: (0, connected_react_router_1.connectRouter)(history),
        loading: loading_1.loading,
        login: login_1.login,
        notification: notification_1.notification,
        multi: multi_1.multi,
    });
};
exports.reducerGen = reducerGen;
